var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVeryBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9837 26.8487C25.4837 25.032 22.917 23.832 20.0003 23.832C17.0837 23.832 14.517 25.032 13.017 26.8487L15.3837 29.2154C16.1337 27.9987 17.917 27.1654 20.0003 27.1654C22.0837 27.1654 23.867 27.9987 24.617 29.2154L26.9837 26.8487Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 18.832C15.5003 18.832 16.667 17.6654 16.667 16.332L11.667 13.832V16.332C11.667 17.6654 12.8337 18.832 14.167 18.832Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8337 18.832C27.167 18.832 28.3337 17.6654 28.3337 16.332V13.832L23.3337 16.332C23.3337 17.6654 24.5003 18.832 25.8337 18.832Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVeryBad);
export default __webpack_public_path__ + "static/media/IconVeryBad.049c381533a9f3c87301426902a1e7b7.svg";
export { ForwardRef as ReactComponent };